import type { SVGProps } from 'react';

import * as styles from './LegacyProfileIcon.css';

interface LegacyProfileIconProps extends SVGProps<SVGSVGElement> {
  tone: 'purple' | 'white' | 'black';
}

export const LegacyProfileIcon = ({
  tone,
  ...props
}: LegacyProfileIconProps) => {
  const themeClasses: Record<LegacyProfileIconProps['tone'], string> = {
    black: styles.blackTheme,
    purple: styles.purpleTheme,
    white: styles.whiteTheme,
  };

  const className = [
    styles.profileIconBase,
    themeClasses[tone],
    props.className,
  ].join(' ');

  return (
    <svg
      {...props}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 420.8 424.7"
      // xml:space="preserve"
    >
      <circle
        className={styles.profileIconHead}
        cx="209.7"
        cy="108.2"
        r="71.2"
      />
      <path
        className={styles.profileIconBody}
        d="M354.9,328.2c0,4.6-2.3,6-6,6c-3.7,0-270.7,0-276.2,0c-5.6,0-5.9-3.2-5.9-6c0-98.2,89.6-138.2,143.2-138.2  C267.7,190.1,354.9,230,354.9,328.2z"
      />
    </svg>
  );
};
